import { render } from "./ContactInformation.vue?vue&type=template&id=1b013858&scoped=true"
import script from "./ContactInformation.vue?vue&type=script&lang=js"
export * from "./ContactInformation.vue?vue&type=script&lang=js"

import "./ContactInformation.vue?vue&type=style&index=0&id=1b013858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b013858"]])

export default __exports__